export default "__VITE_ASSET__BKJ63evm__"